import { useSelector } from "react-redux";
import { getUserRoles } from "./authSlice";

const useUserRoles = () => {
  return useSelector(getUserRoles);
};

export { useUserRoles };
